import { Box, styled } from '@mui/material';
import { localImages } from 'csam/utils/Constants';
import React from 'react';

interface InnerPageWrapperProps {
  children: React.ReactNode;
  className?: string;
  backgroundImage?: string;
  backgroundPosition?: string;
  height?: string;
  overlay?: boolean;
  overlayColor?: string;
  overlayOpacity?: number;
}

const StyledInnerPageWrapper = styled(Box, {
  shouldForwardProp: (prop) => 
    !['backgroundImage', 'backgroundPosition', 'overlay', 'overlayColor', 'overlayOpacity'].includes(prop as string),
})<{ 
  backgroundImage?: string;
  backgroundPosition?: string;
  height?: string;
  overlay?: boolean;
  overlayColor?: string;
  overlayOpacity?: number;
}>(({ 
  backgroundImage, 
  backgroundPosition = '0 -36px',
  height = '100vh',
  overlay = false,
  overlayColor = 'rgba(0, 0, 0, 0.5)',
  overlayOpacity = 0.5
}) => ({
  backgroundImage: `url(${backgroundImage || localImages + 'home-new-bg.jpg'})`,
  height,
  backgroundSize: 'cover',
  backgroundPosition,
  position: 'relative',
  padding: '0 30px',
  '&::before': overlay ? {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: overlayColor,
    opacity: overlayOpacity,
    zIndex: 1
  } : {},
  '& > *': overlay ? {
    position: 'relative',
    zIndex: 2
  } : {}
}));

const InnerPageWrapper: React.FC<InnerPageWrapperProps> = ({ 
  children, 
  className,
  backgroundImage,
  backgroundPosition,
  height,
  overlay,
  overlayColor,
  overlayOpacity
}) => {
  return (
    <StyledInnerPageWrapper 
      className={className} 
      backgroundImage={backgroundImage}
      backgroundPosition={backgroundPosition}
      height={height}
      overlay={overlay}
      overlayColor={overlayColor}
      overlayOpacity={overlayOpacity}
    >
      {children}
    </StyledInnerPageWrapper>
  );
};

export default InnerPageWrapper;